import { useNavigate, useParams } from "react-router-dom"
import PageTitle from "../../components/PageTitle";
import PageContent from "../../components/PageContent";
import { useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import useApi from "../../hooks/ApiHook";
import { InputText } from "primereact/inputtext";
import { Checkbox } from 'primereact/checkbox';
import { Button } from "primereact/button";
import useToast from "../../hooks/ToastHook";
import useUser from "../../hooks/UserHook";

export default function() {

    const { id } = useParams();
    const navigate = useNavigate();
    const api = useApi();
    const { showSuccess, showAxiosError } = useToast();
    const [ loading, setLoading ] = useState(true);
    const [ saving, setSaving ] = useState(false);
    const [ user, setUser ] = useState({ active: true });
    const { self } = useUser();
    const isNew = id === 'new';

    useState(() => {
        if (isNew) {
            setLoading(false);
            return;
        }
        setLoading(true);
        api.get('users/' + id).then(({ data }) => {
            setUser(data);
        }).finally(() => setLoading(false));
    }, [id]);

    const save = e => {
        setSaving(true);
        const request = isNew ? api.post('users', user) : api.put('users/' + id, user);
        request.then(() => {
            showSuccess('Salvo com sucesso');
            navigate(-1);
        }).catch(showAxiosError).finally(() => setSaving(false));
        e.preventDefault();
    }

    return (
        <div>
            <PageTitle title={`${isNew ? 'Novo' : 'Edição de'} usuário`}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <form onSubmit={save}>
                        <div className="formgrid grid">
                            <div className="field col-12">
                                <label>Nome</label>
                                <InputText
                                    value={user.name || ''}
                                    maxLength={50}
                                    onChange={e => setUser({ ...user, name: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Email</label>
                                <InputText
                                    value={user.email || ''}
                                    maxLength={50}
                                    onChange={e => setUser({ ...user, email: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Nome de usuário</label>
                                <div className="p-inputgroup w-full">
                                    <InputText
                                        value={user.loginName || ''}
                                        maxLength={50}
                                        onChange={e => setUser({ ...user, loginName: e.target.value })}
                                        className="w-full"/>
                                    <span className="p-inputgroup-addon">@{self.company.loginDomain}</span>
                                </div>
                            </div>
                            <div className="field-checkbox col-12">
                                <Checkbox 
                                    checked={user.active}
                                    onChange={e => setUser({ ...user, active: e.checked })}/>
                                <label for="city1">Usuário ativo</label>
                            </div>
                        </div>
                        <div className="mt-2">
                            <Button 
                                className="mr-2" 
                                label="Salvar"
                                loading={saving}/>
                            <Button 
                                label="Cancelar" 
                                outlined
                                type="button"
                                disabled={saving}
                                onClick={() => navigate(-1)}/>
                        </div>
                    </form>
                </If>
            </PageContent>
        </div>
    );
}